<template>
  <div class="zjxCheck">
    <div class="zxj_check">
      <div class="zxj_check_title">
        <p>会员校验</p>
      </div>

      <div class="zjx_check_form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="身份证号" prop="idCard">
            <el-input
              class="inner_check_width"
              v-model="ruleForm.idCard"
            ></el-input>
          </el-form-item>
          <el-form-item label="会员号" prop="vipCode">
            <el-input
              class="inner_check_width"
              v-model="ruleForm.vipCode"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input
              class="inner_check_width"
              v-model="ruleForm.name"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button class="register_btn" @click="submitForm('ruleForm')"
              >确认</el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <canvas
        id="mycanvas"
        width="750"
        height="530"
        style="display: none"
        class="my-canvas"
      ></canvas>
    </div>
  </div>
</template>

<script>
import { vaildate } from "../../utils/validate.js";
import { vipCheck } from "../../api/moudles/home.js";
export default {
  data() {
    const isCardId = (rule, value, callback) => {
      if (!value) {
        return new Error("请输入身份证号");
      } else {
        if (rule.field == "idCard") {
          if (!vaildate.isIdCard(value)) {
            callback(new Error("身份证号格式有误"));
          } else {
            callback();
          }
        }
      }
    };
    return {
      ruleForm: {
        idCard: "",
        name: "",
        vipCode: "",
      },
      rules: {
        idCard: [
          {
            required: true,
            message: "请输入身份证号码",
            trigger: "blur",
          },
          {
            validator: isCardId,
            trigger: "blur",
          },
        ],
        vipCode: [
          {
            message: "请输入会员号",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    drawPhoto(data) {
      let canvas = document.getElementById("mycanvas"); //创建canvas
      let context = canvas.getContext("2d"); //创建画布
      let img = new Image(); //因为拿不到图片静态资源，所以创建图片标签
      img.setAttribute("crossOrigin", "anonymous"); //解决图片跨域问题,也要放到赋值前，否ze大部分浏览器会报错
      img.src = require("../../assets/img/userIndex/cartic.png");
      //加载图片
      img.onload = () => {
        canvas.setAttribute("width", img.width);
        canvas.setAttribute("height", img.height);
        //绘制图片
        context.drawImage(img, 0, 0, img.width, img.height);
        //字体大小
        context.font = "bold 40px LiSu";
        //字体文字，显示位置  图片上需要n个文字就写n个context.fillText(文字,上下,左右);
        context.fillText(data.realName + "：", 150, 600);

        context.font = "32px LiSu";
        context.fillText("根据本会章程，经审核，同意接收你为", 230, 660);
        context.fillText("本会个人会员。", 150, 720);

        context.font = "28px LiSu";
        context.fillText("会员编号：" + data.certNumber, 230, 1000);
        context.fillText("发证日期：" + data.effectiveDate, 230, 1050);
        context.fillText("有效期至：" + data.effectiveDateTo, 230, 1100);
        context.fillText("服务主体：" + data.serviceMainLabel, 230, 1150);
        //合成图片
        const image = new Image();
        const val = canvas.toDataURL("image/jpg", 1.0);
        image.src = val;
        image.style.width = "500px";
        image.style.marginLeft = "37%";
        image.style.marginTop = "100px";
        const newOpen = window.open(val);
        newOpen.document.write(image.outerHTML);
      };
    },
    // 会员校验
    async vipCheck() {
      await vipCheck({
        data: {
          idCard: this.ruleForm.idCard,
          realName: this.ruleForm.name,
          memberCode: this.ruleForm.vipCode,
        },
        success: (res) => {
          if (res.code == 200 || res.code == 0) {
            if (res.data) {
              this.drawPhoto(res.data);
            } else {
              this.$message.warning(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.vipCheck();
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .zjxCheck {
    min-height: 620px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .zxj_check {
    width: 100%;
    height: 600px;
    background-color: #fff;
  }
  .zjx_check_form {
    width: 90%;
    margin-left: 5%;
    padding-top: 50px;
  }
  .register_btn {
    width: 350px;
    background-color: #c22c25;
    color: #fff;
    margin-left: -100px;
  }
  .zxj_check_title {
    height: 80px;
    line-height: 80px;
    box-sizing: border-box;
    width: 100%;
    padding-left: 30px;
    font-size: 22px;
    border-bottom: 1px solid #f5f5f5;
  }
}

@media screen and (min-width: 750px) {
  .zjxCheck {
    min-height: 710px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .zxj_check {
    width: 1200px;
    height: 650px;
    background-color: #fff;
  }
  .zjx_check_form {
    width: 36%;
    margin-left: 28%;
    padding-top: 50px;
  }
  .register_btn {
    width: 300px;
    background-color: #c22c25;
    color: #fff;
  }
  .inner_check_width {
    width: 300px;
  }
  .zxj_check_title {
    height: 80px;
    line-height: 80px;
    width: 100%;
    padding-left: 30px;
    font-size: 22px;
    border-bottom: 1px solid #f5f5f5;
  }
}
</style>
